import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const innerPageHeadingDefaultVariants = {}
const innerPageHeadingCompoundVariants = []

const innerPageHeadingSlotNames = [
  [
    "root",
    "inner-page-heading__root"
  ],
  [
    "title",
    "inner-page-heading__title"
  ],
  [
    "picture",
    "inner-page-heading__picture"
  ],
  [
    "image",
    "inner-page-heading__image"
  ],
  [
    "intro",
    "inner-page-heading__intro"
  ]
]
const innerPageHeadingSlotFns = /* @__PURE__ */ innerPageHeadingSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, innerPageHeadingDefaultVariants, getSlotCompoundVariant(innerPageHeadingCompoundVariants, slotName))])

const innerPageHeadingFn = memo((props = {}) => {
  return Object.fromEntries(innerPageHeadingSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const innerPageHeadingVariantKeys = []
const getVariantProps = (variants) => ({ ...innerPageHeadingDefaultVariants, ...compact(variants) })

export const innerPageHeading = /* @__PURE__ */ Object.assign(innerPageHeadingFn, {
  __recipe__: false,
  __name__: 'innerPageHeading',
  raw: (props) => props,
  variantKeys: innerPageHeadingVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, innerPageHeadingVariantKeys)
  },
  getVariantProps
})